import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  Schedule as ScheduleIcon,
  Timeline as TimelineIcon,
  AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import { formatCurrency } from '../../utils/liquidacionHelpers';

const StatCard = ({ title, value, subtitle, icon, color }) => (
  <Card sx={{
    borderRadius: 3,
    background: `linear-gradient(135deg, ${color}15 0%, ${color}25 100%)`,
    border: `1px solid ${color}30`,
    transition: 'all 0.3s ease',
    '&:hover': { transform: 'translateY(-4px)' }
  }}>
    <CardContent sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color, mb: 0.5 }}>
            {value}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: '600', color: '#1A237E' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box sx={{
          p: 2,
          borderRadius: '50%',
          bgcolor: `${color}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {React.cloneElement(icon, { sx: { fontSize: 32, color } })}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const ResumenCards = ({ resumen = {} }) => {
  const { servicios_pendientes = {}, estadisticas_pagos = {} } = resumen;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Servicios Pendientes"
          value={servicios_pendientes.servicios_sin_liquidar || 0}
          subtitle={formatCurrency(servicios_pendientes.comisiones_pendientes)}
          icon={<TrendingUpIcon />}
          color="#4CAF50"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Pagos Pendientes"
          value={estadisticas_pagos.pagos_pendientes || 0}
          subtitle={formatCurrency(estadisticas_pagos.monto_pendiente)}
          icon={<ScheduleIcon />}
          color="#FF9800"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="En Proceso"
          value={estadisticas_pagos.pagos_en_proceso || 0}
          subtitle={formatCurrency(estadisticas_pagos.monto_en_proceso)}
          icon={<TimelineIcon />}
          color="#2196F3"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Pagado Este Mes"
          value={estadisticas_pagos.pagos_mes_actual || 0}
          subtitle={formatCurrency(estadisticas_pagos.monto_pagado_mes)}
          icon={<AccountBalanceIcon />}
          color="#9C27B0"
        />
      </Grid>
    </Grid>
  );
};

export default ResumenCards;
